import CompaniesView from "../CompaniesView.vue";
import ContractList from "../Pages/ContractList.vue";
import ContractDetails from "../Pages/ContractDetails.vue";
import ContractEditor from "../Pages/ContractEditor.vue";
import ContractBulkUploadPage from "../Pages/ContractBulkUploadPage.vue";

const routes = [
  {
    path: '/contratos',
    component: CompaniesView,
    children: [
      {
        path: '',
        name: 'contracts-list',
        component: ContractList,
      },
      {
        path: 'carga-masiva',
        name: 'contracts-bulk-upload',
        component: ContractBulkUploadPage,
      },
      {
        path: ':id/detalle',
        name: 'contracts-details',
        component: ContractDetails,
      },
      {
        path: 'crear',
        name: 'contracts-create',
        component: ContractEditor,
      },
      {
        path: ':id/editar',
        name: 'contracts-edit',
        component: ContractEditor
      },
    ]
  }
]

export default routes
